// for print popup
const popupWindow = (url, title, win, w, h, layout = 'portrait') => {
  const y = win.top.outerHeight / 2 + win.top.screenY - h / 2
  const x = win.top.outerWidth / 2 + win.top.screenX - w / 2
  const newWindow = win.open(
    url,
    Math.random().toString(36),
    `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
  )

  // newWindow.document.title = title
  newWindow.document.write(`<title>${title}</title>`)

  newWindow.document.write(
    '<link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">'
  )
  newWindow.document.write(
    '<link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet">'
  )
  newWindow.document.write(
    '<link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">'
  )
  newWindow.document.write(
    '<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">'
  )
  newWindow.document.write('<link rel="stylesheet" href="/popup.css" />')
  newWindow.document.write('<link rel="stylesheet" href="/priceTag.css" />')
  if (layout === 'portrait') {
    newWindow.document.write('<link rel="stylesheet" href="/printPortrait.css" />')
  } else {
    newWindow.document.write('<link rel="stylesheet" href="/printLandscape.css" />')
  }

  newWindow.document.write(
    // '<div id="outerPrintDiv" class="v-application v-application--is-ltr theme--light"></div>'
    `<div id="outerPrintDiv" class="v-application v-application--is-ltr theme--light" style="display: inline-block;"></div>`
    // '<div id="outerPrintDiv" class="v-application v-application--is-ltr theme--light" style="max-width:1185px;"></div>'
  )

  return newWindow
}

const popupPrintWindow = (url, title, win, portraitWidth, portraitHeight, layout = 'portrait', printElId, callback) => {
  const printEl = document.querySelector(printElId)

  const isPortrait = layout === 'portrait'

  const width = isPortrait ? portraitWidth : portraitHeight
  const height = isPortrait ? portraitHeight : portraitWidth

  const newWindow = popupWindow('', 'Print', win, width, height, layout)
  const outerDiv = newWindow.document.getElementById('outerPrintDiv')
  outerDiv.innerHTML = printEl.outerHTML

  // remove el scroll height
  const popupEl = newWindow.document.querySelector(printElId)
  if (popupEl) {
    popupEl.style.maxHeight = ''
    popupEl.style.height = ''
  }

  // remove previewOnlyBorder
  const previewOnlyBorder = newWindow.document.querySelectorAll('.previewOnlyBorder')
  if (previewOnlyBorder.length > 0) {
    previewOnlyBorder.forEach((p) => (p.style.borderColor = 'transparent'))
  }

  newWindow.document.close()
  newWindow.focus()

  newWindow.onafterprint = function () {
    newWindow.close()

    if (callback !== undefined) {
      callback()
    }
  }

  newWindow.onload = function () {
    newWindow.print()
  }
}

const defaultIfNotExists = (val, def) => {
  return val || def
}

const equalsValue = (object1, object2, excludeFields = [], isIgnoreArrayOrder = false) => {
  const debugLogging = true
  // if (debugLogging) console.log('equalsValue() comparing...', object1, object2, excludeFields)

  if (!object1 || !object2) {
    return object1 === object2
  }

  if (typeof object1 !== typeof object2) return false

  if (typeof object1 !== 'object') return object1 === object2

  if (Array.isArray(object1)) {
    if (object1.length !== object2.length) {
      if (debugLogging) console.log(`has different length: ${object1.length}, ${object2.length}`)
      return false
    } else {
      for (const [i, obj] of object1.entries()) {
        if (isIgnoreArrayOrder) {
          if (!object2.includes(obj)) {
            return false
          }
        } else {
          if (!equalsValue(obj, object2[i], excludeFields)) {
            return false
          }
        }
      }
    }
  } else {
    const keys1 = Object.keys(object1).filter((k) => !excludeFields.includes(k))
    const keys2 = Object.keys(object2).filter((k) => !excludeFields.includes(k))

    if (keys1.length !== keys2.length) {
      if (debugLogging) console.log('different key length: ', keys1.length, keys2.length)
      // console.log('different key: ', JSON.stringify(keys1), JSON.stringify(keys2))

      return false
    }

    for (const key of keys1) {
      if (typeof object1[key] !== typeof object2[key]) {
        if (debugLogging) console.log('different type: ', key, typeof object1[key], typeof object2[key])
        return false
      } else if (typeof object1[key] === 'object') {
        if (equalsValue(object1[key], object2[key], excludeFields) === false) {
          return false
        }
      } else if (object1[key] !== object2[key]) {
        if (debugLogging) console.log('different value: ', key, object1[key], object2[key])
        return false
      }
    }
  }

  return true
}

const deepCopy = (object1) => {
  // return JSON.parse(JSON.stringify(object1))
  if (!object1) {
    return object1
  }

  if (typeof object1 !== 'object') {
    return object1
  }

  if (Array.isArray(object1)) {
    const object2 = []
    for (const obj of object1) {
      object2.push(deepCopy(obj))
    }
    return object2
  } else {
    const object2 = {}
    for (const key of Object.keys(object1)) {
      if (typeof object1[key] === 'object' && !(object1[key] instanceof Date)) {
        object2[key] = deepCopy(object1[key])
      } else {
        object2[key] = object1[key]
      }
    }
    return object2
  }
}

/**
 * Deep copy source to target, preserve target reference
 */
const deepCopyToTarget = (source, target) => {
  clearObject(target)

  if (!source) {
    return
  }

  if (typeof source !== 'object') {
    target = source
  }

  if (Array.isArray(source)) {
    for (const obj of source) {
      target.push(deepCopy(obj))
    }
  } else {
    for (const key of Object.keys(source)) {
      if (typeof source[key] === 'object') {
        target[key] = deepCopy(source[key])
      } else {
        target[key] = source[key]
      }
    }
  }
}

// date format : 2021-05-28 18:05:41
const currentDateTime = () => {
  const date = new Date()
  return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)
    .toISOString()
    .replace(/T/, ' ')
    .replace(/\..+/, '')
}

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const currencyFormatter4 = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4
})

const currencyFormatter0 = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

const decimalFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
})

const decimalFormatter2 = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const percentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

const currencyUSD = (value, withNoSpace = false) => {
  return value || value === 0 ? currencyFormatter.format(value).replace(/^(\D+)/, withNoSpace ? '$1' : '$1 ') : ''
}

const currencyUSDwithDefault = (value, withNoSpace = false) => {
  return value ? currencyFormatter.format(value).replace(/^(\D+)/, withNoSpace ? '$1' : '$1 ') : '$ 0.00'
}

const currencyUSDnumberOnly = (value, fraction = 2) => {
  if (fraction === 4) {
    return value ? currencyFormatter4.format(value).replace('$', '') : '0.0000'
  } else if (fraction === 0) {
    return value ? currencyFormatter0.format(value).replace('$', '') : '0'
  }
  return value ? currencyFormatter.format(value).replace('$', '') : '0.00'
}

const decimal = (value, fraction = 0) => {
  if (fraction === 2) {
    return value || value === 0 ? decimalFormatter2.format(value) : ''
  }
  return value || value === 0 ? decimalFormatter.format(value) : ''
}

const decimalNumber = (value, fraction = 0) => {
  if (fraction === 2) {
    return Number((value || value === 0 ? decimalFormatter2.format(value) : '').replaceAll(',', ''))
  }
  return Number((value || value === 0 ? decimalFormatter.format(value) : '').replaceAll(',', ''))
}

const decimalWithDefault = (value) => {
  return value ? decimalFormatter.format(value) : '0'
}

const percentage = (value) => {
  return value || value === 0 ? percentFormatter.format(value) : ''
}

const percentageWithDefault = (value) => {
  return value ? percentFormatter.format(value) : '0.00%'
}

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const range = (start, end, length = end - start + 1) => Array.from({ length }, (_, i) => start + i)

/**
 * Return 0 base range array
 *
 * ex. pageRange(2, 15, 10)
 * returns [10, 11, 12, 13, 14]
 */
const pageRange = (page, total, perPage) => {
  if (page < 1) return []
  if (total < 1) return []

  if (total <= perPage) {
    return page === 1 ? range(0, total - 1) : []
  }

  let start = 1
  if (page > 1) {
    start = (page - 1) * perPage + 1
  }

  const end = total >= page * perPage ? page * perPage : total

  return range(start - 1, end - 1)
}

const fieldSum = (array, field) => {
  if (!array || array.length === 0) {
    return 0
  }

  return array.map((a) => a[field] || 0).reduce((a, b) => Number(a) + Number(b), 0)
}

const fieldSumAbsolute = (array, field) => {
  if (!array || array.length === 0) {
    return 0
  }

  return array.map((a) => ((a[field] || 0) >= 0 ? a[field] : -a[field])).reduce((a, b) => a + b, 0)
}

const groupByKey = (array, ...keys) => {
  if (!array || array.length === 0) {
    return {}
  }

  return array.reduce((result, currentValue) => {
    const _key = keys.map((key) => currentValue[key]).join('_')
    result[_key] = result[_key] || []
    result[_key].push(currentValue)
    return result
  }, {})
}

/**
 * Clear object, preserve reference
 */
const clearObject = (obj) => {
  if (!obj) return

  if (Array.isArray(obj)) {
    obj.length = 0
  }

  for (const key of Object.keys(obj)) {
    delete obj[key]
  }
}

/**
 * Clear array, preserve reference
 */
const clearArray = (obj) => {
  obj.length = 0
}

const selectRow = (tableClass, rowIndex) => {
  document.querySelectorAll(`.${tableClass} tbody tr`).forEach((el) => {
    el.classList.remove('lighten-5')
    el.classList.remove('light-blue')
  })

  if (rowIndex !== -1) {
    document.querySelector(`.${tableClass} tbody tr:nth-child(${rowIndex + 1})`).classList.add('lighten-5')
    document.querySelector(`.${tableClass} tbody tr:nth-child(${rowIndex + 1})`).classList.add('light-blue')
  }
}

const substringByPrefixPostfix = (input, prefix, postfix) => {
  if (!input || input.trim().length === 0 || !prefix || !postfix) {
    return ''
  }

  if (!input.includes(prefix)) return ''

  const startIndex = input.indexOf(prefix) + prefix.length
  const endIndex = input.indexOf(postfix, startIndex)

  if (endIndex === -1) return ''

  return input.substring(startIndex, endIndex)
}

/** Remove [] from array param */
const paramsSerializer = (paramObj) => {
  const params = new URLSearchParams()
  for (const key in paramObj) {
    if (paramObj[key] === undefined || paramObj[key] === null) continue
    if (Array.isArray(paramObj[key]) && paramObj[key].length === 0) continue

    params.append(key, paramObj[key])
  }

  return params.toString()
}

const round = (value) => Math.round(value * 100) / 100

const roundToFixed = (value) => Number(Math.round(value * 100) / 100).toFixed(2)

const toggleCheckAll = (checked, list) => {
  for (const item of list) {
    item.isSelected = checked
  }
}

const camelSentence = (str) => {
  return (' ' + str).toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (match, chr) {
    return chr.toUpperCase()
  })
}

const isBlank = (str) => {
  return (str || '').trim().length === 0
}

const sizeArray = (str, strSize) => {
  const sizes = []
  while (str.length > 0) {
    if (str.substring(0, strSize).trim() !== '') sizes.push(str.substring(0, strSize).trim())
    str = str.substring(strSize, str.length)
  }
  return sizes
}

const equalsIgnoreCase = (value1, value2) => {
  if (typeof value1 !== typeof value2) return false

  const v1 = value1 ? value1.toUpperCase() : ''
  const v2 = value2 ? value2.toUpperCase() : ''

  return v1 === v2
}

const unitSum = (item, unitPrefix = 'unit') => {
  if (!item) {
    return 0
  }

  let sum = 0
  for (const unitNum of range(1, 30)) {
    const unitCount = item[`${unitPrefix}${unitNum}`] || 0
    sum += Number(isNaN(unitCount) ? 0 : unitCount)
  }

  return sum
}

const makeComma = (str) => {
  return String(str).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const voidMethod = () => {}

/**
 * ex)
 * lotRolls.sort(g.sortBy('style a', 'color a', 'lotNo a', 'rollNo a', 'warehouse a', 'dmgShort a'))
 * @param  sortFields (sortField a(asc)/d(desc))
 * @returns
 */
const sortBy = (...sortFields) => {
  return function (a, b) {
    return compareBySortField(a, b, sortFields)
  }
}

const compareBySortField = (a, b, sortFields) => {
  if (sortFields.length === 0) return 0

  const field = sortFields[0]

  const sortField = field.split(' ')[0]
  const sortOrder = field.split(' ').length === 2 && field.split(' ')[1] === 'd' ? 'desc' : 'asc'

  if (String(a[sortField] || '').toLowerCase() < String(b[sortField] || '').toLowerCase()) {
    return sortOrder === 'asc' ? -1 : 1
  } else if (String(a[sortField] || '').toLowerCase() > String(b[sortField] || '').toLowerCase()) {
    return sortOrder === 'asc' ? 1 : -1
  } else {
    return compareBySortField(a, b, sortFields.slice(1))
  }
}

const uniqueArray = (array) => {
  return array ? [...new Set(array)] : []
}

const createElFromHTML = (htmlString) => {
  const div = document.createElement('div')
  div.innerHTML = htmlString.trim()

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild
}

const showMandatoryFieldSymbol = (parentElClass = '') => {
  if (parentElClass) {
    parentElClass = `.${parentElClass}`
  }

  nextTick(() => {
    console.log(`${parentElClass} .isMandatory label:not([style*="visibility:hidden"])`)

    for (const mandatoryEl of document.querySelectorAll(`${parentElClass} .isMandatory`)) {
      console.log('mandatoryEl', mandatoryEl)

      if (mandatoryEl.querySelector('label')) {
        // display asterisk for label

        const el = mandatoryEl.querySelector('label')
        let label = el.textContent
        if (label.endsWith('*')) {
          label = label.substring(0, label.length - 1)
        }
        el.innerHTML = `${label}<span style="color: red;padding-left:3px">*</span>`
      } else if (mandatoryEl.querySelector('.v-card__title')) {
        // display asterisk for card title - card element

        const el = mandatoryEl.querySelector('.v-card__title')
        let label = el.textContent
        if (label.endsWith('*')) {
          label = label.substring(0, label.length - 1)
        }
        el.innerHTML = `${label}<span style="color: red;padding-left:3px">*</span>`
      } else if (mandatoryEl.classList.contains('mandatory-check')) {
        // display asterisk for direct element

        const el = mandatoryEl
        let label = el.textContent
        if (label.endsWith('*')) {
          label = label.substring(0, label.length - 1)
        }
        el.innerHTML = `${label}<span style="color: red;padding-left:3px">*</span>`
      } else {
        // add label

        const el = mandatoryEl.querySelector('.v-input__control .v-input__slot')
        if (el) {
          el.insertBefore(
            createElFromHTML(
              '<label class="v-label v-label--active theme--light" style="left: 0px; right: auto; top: 15px; position: absolute;"><span style="color: red;padding-left:3px">*</span></label>'
            ),
            el.firstChild
          )
        }
      }
    }
  })
}

const isNumber = (value) => {
  return !!Number(value) || Number(value) === 0
}

/**
 * ex.
 *  mapToKeyValueObjects([{colorCode:'black', msrp: 10},{colorCode:'blue', msrp: 12}], 'colorCode', 'msrp')
 *  => {black: 10, blue: 12}
 */
const mapToKeyValueObjects = (array, keyField, valueField) => {
  if (!array || array.length === 0) {
    return {}
  }

  return array.reduce((result, currentValue) => {
    const key = currentValue[keyField]
    result[key] = result[key] || currentValue[valueField]
    return result
  }, {})
}

const functionMapToKeyValueObjects = (array, keyField, valueMapFunction) => {
  if (!array || array.length === 0) {
    return {}
  }

  return array.reduce((result, currentValue) => {
    const key = currentValue[keyField]
    result[key] = result[key] || valueMapFunction(currentValue)
    return result
  }, {})
}

const split = (value, separator) => {
  if (!value || value.trim().length === 0) {
    return []
  } else {
    return value.split(separator)
  }
}

const removeSpecialCharacters = (strValue, withString = '', specialCharType = e.SpecialCharType.ALL) => {
  let regex
  switch (specialCharType) {
    case e.SpecialCharType.N41CODE:
      regex = /[^0-9A-Za-z \.%\/_-]/g // Matches anything that is not a letter, digit, space, or these special characters
      break
    case e.SpecialCharType.FILENAME:
      regex = /[\\/:*?"<>|]/g // Matches characters that are not allowed in file names
      if (withString === '') withString = '-' // Default replacement for file name chars
      break
    default:
      regex = /\W/g // Matches any non-word character (equivalent to [^A-Za-z0-9_])
      break
  }
  return strValue.replace(regex, withString).trim()
}

const sumObjValues = (obj) => Object.values(obj).reduce((total, val) => total + parseInt(val || 0, 10), 0)
const sumArray = (arr) => arr.reduce((total, num) => total + num, 0)
const urlEncode = (rawString) => encodeURIComponent(rawString)
const urlDecode = (rawString) => decodeURIComponent(rawString)
const omitKeys = (obj, keys = []) => {
  return Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)))
}

export const g = {
  camelSentence,
  clearArray,
  clearObject,
  createElFromHTML,
  currentDateTime,
  currencyUSD,
  currencyUSDwithDefault,
  currencyUSDnumberOnly,
  decimal,
  decimalNumber,
  decimalWithDefault,
  deepCopy,
  deepCopyToTarget,
  defaultIfNotExists,
  equalsValue,
  equalsIgnoreCase,
  fieldSum,
  fieldSumAbsolute,
  functionMapToKeyValueObjects,
  groupByKey,
  isBlank,
  isNumber,
  makeComma,
  mapToKeyValueObjects,
  pageRange,
  paramsSerializer,
  percentage,
  percentageWithDefault,
  popupWindow,
  popupPrintWindow,
  range,
  round,
  roundToFixed,
  selectRow,
  showMandatoryFieldSymbol,
  sizeArray,
  substringByPrefixPostfix,
  sleep,
  sortBy,
  split,
  toggleCheckAll,
  unitSum,
  uniqueArray,
  voidMethod,
  removeSpecialCharacters,
  sumObjValues,
  sumArray,
  urlEncode,
  urlDecode,
  omitKeys
}
